module.exports = __webpack_public_path__ + "img/cart-items-active.6eff3ad.svg";